import { render, staticRenderFns } from "./BoxPerformanceComparisonLineAM.vue?vue&type=template&id=f0dcdf04&scoped=true&"
import script from "./BoxPerformanceComparisonLineAM.vue?vue&type=script&lang=js&"
export * from "./BoxPerformanceComparisonLineAM.vue?vue&type=script&lang=js&"
import style0 from "./BoxPerformanceComparisonLineAM.vue?vue&type=style&index=0&id=f0dcdf04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dcdf04",
  null
  
)

export default component.exports
import {QCard,QBtnToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtnToggle})
